module.exports = __webpack_public_path__ + "static/media/padel.bf4c34a2.svg";